export const CATEGORIES_FOR_SELECT = [
  {
    expense: [
      "Продукты",
      "Алкоголь",
      "Развлечение",
      "Здоровье",
      "Транспорт",
      "Все для дома",
      "Техника",
      "Коммуналка, связь",
      "Спорт, хобби",
      "Образование",
      "Прочее",
    ],
  },
  { income: ["ЗП", "Доп. доход"] },
];

export const BASE_URL = "https://api-kapusta.herokuapp.com";
